export default {
	'component.tagSelect.expand': '展开',
	'component.tagSelect.collapse': '收起',
	'component.tagSelect.all': '全部',
	'tableForm.collapse': '展开',
	'tableForm.expand': '收起',
	'tableForm.submit': '查询',
	'tableForm.reset': '重置',
	'tableForm.inputPlaceholder': '请输入',
	'tableForm.selectPlaceholder': '请选择'
};
